// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5c71d18d","453":"6470a8f6"}[chunkId] + ".chunk.js";
};